import { FormsContactOrderBy, FormsContactService } from "../client"

/* Interfaces */
export interface DetailContactProps {
  onClose: () => void
  isOpen: boolean
  contactId: string
}


/* Endpoints */
export const readFormsContacts = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: FormsContactOrderBy
    descending?: boolean
    query?: string
}) => {
  return {
    queryFn: async () => {
      const data = await FormsContactService.readFormsContact({
        skip: (page - 1) * per_page,
        limit: per_page,
        orderBy: order_by,
        descending: descending,
        query: query,
      })

      return data ?? { data: null, count: 0 }
    },
    queryKey: ["forms-contacts", { page, order_by, descending, query }],
  }
}

export const readFormsContactById = (contactId: string) => {
  return {
    queryFn: async () => {
      const data = await FormsContactService.readFormsContactById({ contactId: contactId })

      return data ?? { data: null, count: 0 }
    },
    queryKey: ["contact", { contactId }],
  }
}